export const edwinGroupName = 'edwin_stock_group_1';
